<template>
  <div class="MemberStudy">
    <TabPaneContent :type="0" />
    <!-- <el-tabs class="courseTab" v-model="activeName">
      <el-tab-pane label="系统课" name="0">
        <TabPaneContent :type="0" />
      </el-tab-pane>
      <el-tab-pane label="赠课" name="1" lazy>
        <TabPaneContent :type="1" />
      </el-tab-pane>
      <el-tab-pane label="资料课" name="2" lazy>
        <TabPaneContent v-if="activeName === '2'" :type="2" />
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>
import { triggerLoaded } from '@/components/LoadContainer.vue';
import TabPaneContent from './TabPaneContent.vue';

export default {
  name: 'MemberStudy',
  components: {
    TabPaneContent,
  },

  data() {
    return {
      activeName: '0',
    };
  },

  async created() {
    triggerLoaded(this);
  },
  mounted() {
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'study_my_task_tab_click',
        event_type: 'click',
      });
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.MemberStudy {
  .courseTab {
    ::v-deep {
      .el-tabs__header {
        padding: 13px 32px 13px 8px;
        border-radius: 8px;
        background: #fff;
        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }
          .el-tabs__active-bar {
            display: none;
            border-radius: 20px;
            background: #f55;
          }
          .el-tabs__item {
            position: relative;
            height: 30px;
            margin: 0 16px;
            padding: 0 8px;
            line-height: 30px;
            color: #706e79;
            font-size: 16px;
            &.is-active {
              color: #000 !important;
              font-weight: 500;
              &::after {
                content: '';
                position: absolute;
                display: inline-block;
                bottom: 0;
                height: 2px;
                width: 24px !important;
                border-radius: 20px;
                background: #f55;
                left: 50% !important;
                transform: translateX(-50%) !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
